import React from 'react';
import {
  DashboardContainerHeader,
  ScrollContainer,
} from 'app/layout/dashboardLayout/BoxLayout';

const PrivacyPolicyRoutes = () => {
  return (
    <ScrollContainer className="border border-gray-100 rounded-md shadow w-full h-full xl:rounded-tl-3xl xl:rounded-bl-3xl">
      {/* Header */}
      <DashboardContainerHeader title="Privacy Policy" />

      {/* Content */}
      <div className="p-6 text-gray-700 text-sm">
        <p>
          Welcome to the <strong>Accountants on Air</strong> privacy policy.
          Your privacy is important to us, and this document explains how we
          collect, use, and share your information.
        </p>

        {/* Section 1 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            1. Information We Collect
          </h2>
          <p>
            We may collect personal information such as your name, email, phone
            number, billing details, and usage data when you use the app.
          </p>
        </div>

        {/* Section 2 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            2. How We Use Your Information
          </h2>
          <p>
            We use your information to improve app functionality, provide
            services, and communicate with you about your account.
          </p>
        </div>

        {/* Section 3 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            3. Sharing Your Information
          </h2>
          <p>
            We do not sell your data but may share it with service providers or
            legal authorities as necessary.
          </p>
        </div>

        {/* Section 4 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            4. Data Security
          </h2>
          <p>
            We implement industry-standard security measures to protect your
            information.
          </p>
        </div>

        {/* Section 5 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            5. Your Rights
          </h2>
          <p>
            You may have the right to access, correct, or delete your data based
            on local laws.
          </p>
        </div>

        {/* Section 6 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            6. Updates to This Policy
          </h2>
          <p>
            We may update this policy and will notify you of changes via email
            or app notifications.
          </p>
        </div>

        {/* Section 7 */}
        <div className="mt-6">
          <h2 className="text-base font-semibold text-green-600">
            7. Contact Us
          </h2>
          <p>
            If you have questions, contact us at{' '}
            <a
              href="mailto:info@acctsonair.com"
              className="text-blue-500 underline"
            >
              info@acctsonair.com
            </a>{' '}
            / + 1 800-518-1063
          </p>
        </div>
      </div>
    </ScrollContainer>
  );
};

export default PrivacyPolicyRoutes;
